<div class="modal-header">
  @if (isNewMachineGroup) {
    <h4 class="modal-title h5" translate>New Machinery Group</h4>
  }
  @if (!isNewMachineGroup) {
    <h4 class="modal-title h5" translate>Edit Machinery Group</h4>
  }
  <button type="button" class="close" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<form [formGroup]="machineGroupForm" (ngSubmit)="onSave()">
  <div class="modal-body">
    <div class="form-row">
      <div class="col-12 col-md-6">
        <!--NAME-->
        <div class="form-group">
          <label for="name" translate>Name</label>
          <scitis-required-field-indicator></scitis-required-field-indicator>
          @if (submitted && this.f.name.pending) {
            <span class="fa-solid fa-spinner fa-spin"></span>
          }
          <input name="name" formControlName="name" id="name" type="text" class="form-control"
            [ngClass]="{ 'is-invalid': submitted && f.name.errors }">

            @if (submitted && f.name.errors) {
              <div class="invalid-feedback">
                @if (f.name.errors.required) {
                  <span translate>Name required</span>
                }
                @if (f.name.errors.duplicatedName) {
                  <span>
                    <span translate>Machinery group with name </span>
                    <span [innerText]="f.name.value"></span>
                    <span translate> already exist</span>
                  </span>
                }
              </div>
            }

          </div>
        </div>

        @if (!isNewMachineGroup) {
          <div class="col-12 col-md-6">
            <!--External id-->
            <div class="form-group">
              <label for="externalId" translate>External id</label>
              <input name="externalId" formControlName="externalId" id="externalId" type="text"
                [disabled]="true" [readonly]="true" class="form-control">
              </div>
            </div>
          }
          <div class="col-12 col-md-6" [ngClass]="{'col-md-12':!isNewMachineGroup}">
            <!--PARENT-->
            <div class="form-group">
              <label for="parentId">
                <span translate>Parent</span>
                <scitis-required-field-indicator></scitis-required-field-indicator>
                @if (isLoadingParents) {
                  <span class="fa-solid fa-spinner fa-spin ml-2"></span>
                }
              </label>
              @if (!shouldHideParentDropDown()) {
                <ng-select (change)="onParentChange($event)" id="parentId" formControlName="parentId"
                  [ngClass]="{ 'is-invalid': submitted && f.parentId.errors }"
                  [items]="possibleParents" bindLabel="name" bindValue="id">
                </ng-select>
              }
              @if (shouldHideParentDropDown()) {
                <input name="parentName" id="parentName" type="text" class="form-control" [disabled]="true"
                  >
              }
              @if (submitted && f.parentId.errors) {
                <div class="invalid-feedback">
                  @if (f.parentId.errors.required || f.parentId.errors.min) {
                    <span translate>Parent machinery group
                    required</span>
                  }
                </div>
              }
            </div>
          </div>
        </div>

        <div class="divider"></div>

        <h5 class="h6" translate>Selected machines</h5>

        <div class="scrollarea" style="max-height: 300px;">
          <div class="form-row">
            @if (machineGroup.machines.length === 0) {
              <div class="col-12">
                <div class="alert alert-info" translate>Currently no machines are selected, please add machines below.</div>
              </div>
            }
            @for (machine of machineGroup.machines; track machine) {
              <div class="col-12 col-md-6">
                <div class="card card-sm mb-2">
                  <div class="card-body">
                    <div class="form-row">
                      <div class="col-auto">
                        <button class="btn btn-outline-danger btn-xs" (click)="onRemoveMachine(machine)"
                          [disabled]="!isAdminOrHigher && !isDistributorRole"
                          title="{{'Delete machine' | translate}}"><span class="fa-solid fa-trash"></span>
                        </button>
                      </div>
                      <div class="col">
                        <strong [innerText]="machine.name"></strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>

        <div class="divider"></div>

        <div class="form-group">
          <label for="machineSelection">
            <span translate>Select machine</span>
            @if (isLoadingMachines) {
              <span class="fa-solid fa-spinner fa-spin ml-2"
              ></span>
            }
          </label>

          <div class="row">
            <div class="col">
              <ng-select [(ngModel)]="selected"
                (ngModelChange)="onSelectedMachine()"
                id="machineSelection"
                [ngClass]="{ 'is-invalid': submitted && f.machines.errors }" [ngModelOptions]="{standalone: true}"
                [disabled]="!isAdminOrHigher && !isDistributorRole"
                [items]="possibleMachines"
                bindLabel="name">
              </ng-select>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <div class="modal-footer-inner">
          <div class="row align-items-center flex-fill">
            <div class="col">
              <scitis-required-field-indicator-explanation></scitis-required-field-indicator-explanation>
            </div>
            <div class="col-auto">
              <button type="button" class="btn btn-outline-primary mr-2" (click)="onCancel()">
                <span translate>Cancel</span>
              </button>
              <button type="submit" class="btn btn-primary" [disabled]="(!isAdminOrHigher && !isDistributorRole) || isDisabledSaveBtn">
                <span translate>Save</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
